import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AffiliateHostService } from '../services/affiliate-host.service';

/**
 * Matches the affiliate-portal routes ONLY when the app is loaded on a partner
 * host (`{affiliation}.partner.atsmako.{tld}`, or the non-prod `?affiliation=`
 * override). On any other host these routes are skipped and the master routes
 * match instead.
 */
export const partnerHostGuard: CanMatchFn = () =>
  inject(AffiliateHostService).isPartnerHost();

/** Inverse of {@link partnerHostGuard}: matches the master routes only off a partner host. */
export const masterHostGuard: CanMatchFn = () =>
  !inject(AffiliateHostService).isPartnerHost();
